export default __webpack_public_path__ + "static/media/CreateWorkflowImage.fa4af1f7.svg";